import './App.css';
import Followers from './components/Followers'
import Footer from './components/Footer';
function App() {
  return (
    <div className="App">
      <h1>Anthony Harold's Followers</h1>
      <Followers/>
      <Footer/>
    </div>
  );
}
export default App;